<div>
  <mat-form-field
    appearance="outline"
    [ngClass]="{
      'mat-form-field-invalid': !isMemoValid,
      'disable-memo': readonly || (memo.disabled && !readonly),
      'disable-memo-checkout': readonly,
      'disable-memo-free-gift': memo.disabled && !readonly
    }"
  >
    <input
      matInput
      #memo
      type="text"
      class="memoInput"
      (change)="onChange()"
      [formControl]="getControl() | async"
      [attr.disabled]="readonly ? 'disabled' : null"
      [readonly]="readonly"
      placeholder="{{ showMemoPlaceholder() ? '' : ('cart.cartItem.memoPlaceholder' | cxTranslate) }}"
      #tooltip="matTooltip"
      (mouseover)="showMemoTooltip($event, tooltip)"
      (click)="showMemoTooltip($event, tooltip, 2000)"
      matTooltip="{{ memoIsTruncated ? memo.value : null }}"
      matTooltipClass="memo-tooltip"
      matTooltipPosition="below"
    />
  </mat-form-field>

  @if (!isLimitValid && !isMemoValid) {
  <mat-error>
    {{ 'cart.cartItem.memoErrors.invalidLimit' | cxTranslate }}
  </mat-error>
  } @if (!isInputValid && !isMemoValid) {
  <mat-error>
    {{ 'cart.cartItem.memoErrors.invalidInput' | cxTranslate }}
  </mat-error>
  }
</div>
